import script from "./UsersRegistrationTaskDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersRegistrationTaskDetail.vue?vue&type=script&setup=true&lang=js"

export default script